import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Entry from './library/pages/Entry';
import Presentation from './library/pages/Presentation';
import FlytOgRytme from './library/pages/FlytOgRytme';
import Case from './library/pages/Case';
import HowTo from './library/components/HowTo';
import PrivacyPolicy from './Users/PrivacyPolicy';
import SpeechSounds from './sounds/pages/SpeechSounds';






import Login from './Users/Login';
import Register from './Users/Register';
import Verify from './Users/Verify';
import ForgotPassword from './Users/ForgotPw';
import ResetPw from './Users/ResetPw';
import AccessInterface from './Users/AccessInterface';
import UserSettings from './Users/UserSettings';

import CourseDeepLink from './library/pages/CourseDeepLink';

import './index.css';

import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthProvider';
import { ActivityProvider } from './context/ActivityProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  
    <BrowserRouter>
      <AuthProvider>
        <ActivityProvider>
          <Routes>
            <Route path="/" element={<Entry />} />
            <Route path="/case" element={<Case />} />
            <Route path="/presentation" element={<Presentation />} />
            <Route path="/flytogrytme" element={<FlytOgRytme />} />
             <Route path="/course/:courseId" element={<CourseDeepLink />} />
            <Route path="login" element={<Login/>} />
            <Route path="verify/:id/:code" element={<Verify/>}/>
            <Route path="forgotpassword" element={<ForgotPassword/>}/>
            <Route path="resetpassword/:id/:code" element={<ResetPw />}/>
            <Route path="accessinterface" element={<AccessInterface />}/>
            <Route path="usersettings" element={<UserSettings />}/>
            <Route path='howto' element={<HowTo />}/>
            <Route path='sounds' element={<SpeechSounds />}/>
            <Route path="/policy" element={<PrivacyPolicy />} />
          </Routes>
          </ActivityProvider>
      </AuthProvider>
    </BrowserRouter>    

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
